<template>
  <v-container>
    <v-layout justify-center align-center>
      <v-flex md10>
        <v-radio-group v-model="typeImport" row >
          <v-radio label="Json" value="json"></v-radio>
          <v-radio label="Archivo" value="archivo"></v-radio>
        </v-radio-group>
        <v-row dense>
          <v-col cols="12" v-if="typeImport == 'json'" class="pa-5">
              <ImportData :on-success="handleSuccess" :before-upload="beforeUpload"/>
              <v-alert v-if="results" border="top" color="green" type="success" class="ma-2">
                {{message}}
              </v-alert>
          </v-col>
          <v-col cols="12" v-if="typeImport == 'archivo'" class="pa-5">
              <v-file-input
              v-model="chosenFile"
              show-size small-chips
              label="Cargar Arhivo"
              @change="setFile"
              outlined
              dense>
              </v-file-input>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="sendImport.link"
              label="Link"
              outlined
              dense>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="sendImport.data.key"
              label="Clave"
              outlined
              dense>
            </v-text-field>
          </v-col>

          <v-layout justify-end>
            <v-btn class="green darken-1 mr-3" dark outlined @click="send">
              <v-icon left> mdi-cloud-upload </v-icon>Guardar
            </v-btn>
          </v-layout>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ImportData from '@/components/ImportData'
export default {
  data: () => ({
    typeImport: 'json',
    results: null,
    message: '',
    chosenFile: null,
    sendImport: {
      link: '',
      data: {
        key: ''
      }
    }
  }),
  components: {
    ImportData
  },
  methods: {
    beforeUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 20
      if (isLt1M) {
        return true
      }
      console.log({
        message: isLt1M + ' --Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    handleSuccess (excelData) {
      if (excelData.Numberpage === 1) {
        this.message = `se agrego 1 pestaña con ${excelData[excelData.page[0]].results.length} Registros`
      } else {
        let rows = 0
        excelData.page.map(name => {
          rows += excelData[name].results.length
        })
        this.message = `se agrego ${excelData.Numberpage} pestañas, total de regisros ${rows}`
      }
      this.sendImport.data.results = excelData
      this.results = excelData
    },
    setFile (file) {
      this.chosenFile = file
      this.sendImport.data.file = file
    },
    ...mapActions(['postUrlImportDataServerAction']),
    send () {
      this.sendImport.type = this.typeImport
      this.postUrlImportDataServerAction(this.sendImport)
    }
  },
  computed: {
    ...mapGetters(['get_objectImport'])
  },
  watch: {
    typeImport () {
      this.results = null
      this.chosenFile = null
      this.message = ''
    },
    get_objectImport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
      }
    }
  }
}
</script>

<style>

</style>
